import React from 'react';
import SectionWrapper from './SectionWrapper';
import { useAppData } from '../../context/AppContext';
import { exportNotesPDF } from '../../utils/pdf';
import { format } from 'date-fns';
import * as FiIcons from 'react-icons/fi';

export default function DailyNotes() {
  const { currentDaily, updateCurrentDaily, currentDate } = useAppData();

  const handleDownload = () => {
    exportNotesPDF(format(currentDate, 'EEEE, dd MMMM yyyy'), currentDaily.dailyNotes);
  };

  const wordCount = currentDaily.dailyNotes.trim() ? currentDaily.dailyNotes.trim().split(/\s+/).length : 0;

  return (
    <SectionWrapper title="Daily Notes" onDownload={handleDownload}>
      <div className="mb-6 space-y-2 border-b border-app-border/40 pb-6">
        <p className="text-xs font-black uppercase tracking-[0.2em] text-app-accent flex items-center gap-2">
          <FiIcons.FiInfo /> Contextual Intelligence
        </p>
        <p className="text-sm text-app-muted max-w-xl leading-relaxed">
          Record overarching market themes, upcoming economic data releases, and sector-wide observations that influence today's volatility environment.
        </p>
      </div>

      <textarea 
        value={currentDaily.dailyNotes} 
        onChange={e => updateCurrentDaily({ ...currentDaily, dailyNotes: e.target.value })}
        placeholder="Focus on macro catalysts: CPI, FOMC, Earnings, Geopolitics..."
        className="w-full h-64 resize-y text-lg leading-relaxed p-8 bg-app-surface/30 rounded-2xl border-app-border focus:border-app-accent shadow-inner"
      />
      <div className="mt-4 text-xs font-mono text-app-muted flex justify-end tracking-widest uppercase">
        {wordCount} words • {currentDaily.dailyNotes.length} characters
      </div>
    </SectionWrapper>
  );
}